import { Tag as AntTag } from 'antd';
import React from 'react';
import styled from 'styled-components';

export const Tag = styled(AntTag)`
  font-family: var(--title-font-family);
  font-weight: 700;
  text-transform: uppercase;
  color: #fff;
  font-size: 0.7rem;
  margin-bottom: 10px;
`;

interface IProps {
  type: string;
}

export const ContentTypeTagGlobal = ({ type }: IProps) => {
  const colors = {
    revista: '#ef0a41',
    livro: '#2296ff',
    video: '#8b36e8',
    informativo: '#df3d00'
  };

  const texts = {
    livro: 'Livro',
    revista: 'Revista',
    video: 'Vídeo',
    informativo: 'Informativo'
  };

  return (
    <Tag color={colors[`${type}`.trim().toLocaleLowerCase()]}>
      {texts[`${type}`.trim().toLocaleLowerCase()]}
    </Tag>
  );
};
